(function($){

$(document).ready(function(){

$('.header__nav-button').click(function(){
  $(this).toggleClass('header__nav-button_open');
  $('body').toggleClass('open');
})


$('.hero-banner').slick({
    infinite: true,
    dots:false,
    arrows: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          autoplay: true,
          autoplaySpeed: 2000,
        }
      }
  
    ]

  });

  $('.arrow-flex .cat-prev-slide').on('click', function() {
    $('.hero-banner.slick-slider').find('.slick-prev').trigger('click');
});


$('.arrow-flex .cat-next-slide').on('click', function() {
    $('.hero-banner.slick-slider').find('.slick-next').trigger('click');
});


$('.features-slide').slick({
  infinite: true,
  dots:false,
  arrows: true

});

$('.features-arrow .cat-prev-slide').on('click', function() {
  $('.features-slide.slick-slider').find('.slick-prev').trigger('click');
});


$('.features-arrow .cat-next-slide').on('click', function() {
  $('.features-slide.slick-slider').find('.slick-next').trigger('click');
});

    
$('.spill-covered-slide').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 6,
  slidesToScroll: 6,
  prevArrow:"<button class='slick-prev'><img class='img-fluid' src='//nospill.com/cdn/shop/t/21/assets/prev-arrow.svg?v=178093620794443038401739382970'></button>",
      nextArrow:"<button class='slick-next'><img class='img-fluid' src='//nospill.com/cdn/shop/t/21/assets/next-arrow.svg?v=4795388016879861701739382970'></button>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});

$('.consumer-reviews-slide').slick({
  infinite: true,
  dots:true,
  arrows: false

});


$('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots:false,
  arrows: false,
  fade: true,
  asNavFor: '.slider-nav',
  responsive: [
  
    {
      breakpoint: 767,
      settings: {
        dots:true
      }
    }

  ]
});
$('.slider-nav').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.slider-for',
  dots:false,
  infinite: false,
  vertical:true,
  centerMode: false,
  focusOnSelect: true,
  prevArrow:"<button class='slick-prev'><img class='img-fluid' src='//nospill.com/cdn/shop/t/21/assets/prev-arrow.svg?v=178093620794443038401739382970'></button>",
      nextArrow:"<button class='slick-next'><img class='img-fluid' src='//nospill.com/cdn/shop/t/21/assets/next-arrow.svg?v=4795388016879861701739382970'></button>",

});
	



	$('.popup-youtube').magnificPopup({
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false
	});



});



})(jQuery);


